import { Settings } from "./settings";
import { Labels } from "./labels";
import { stdTimezones, dsTimezones } from "./timezones";

export var Utils = {
    eventQueue: [],
    retryCount: 0,
    timer: null,
    monthNames: [],
    processSearchResults(response, results, append) {
        if (!response || !results) return results;
        var res = null;
        if (typeof (response.data) === "string" && response.data.length > 0) {
            res = JSON.parse(response.data);
        }
        else res = response.data;

        if (res) {
            if (res.error) {
                console.error(res.error);
                return results;
            }
            if (results.rows.length > 0 && append == true) {
                if (res.rows && res.rows.length > 0) {
                    results.rows.push.apply(results.rows, res.rows);
                }
            }
            else {
                results = res;
            }
        }
        else {
            console.info("Cannot retrieve search results. Unexpected response received from server.")
        }
        return results;
    },
    processSDSSearchResults(response) {
        if (!response) return { rows: [], totalRows: 0 };
        var res = null;
        if (typeof (response.data) === "string" && response.data.length > 0) {
            res = JSON.parse(response.data);
        }
        else res = response.data;

        if (res) {
            return { rows: res, totalRows: res.length };
        }
        else {
            console.info("Cannot retrieve search results. Unexpected response received from server.")
        }
    },
    constructQueryUrl(type, query, results, selectedFacets) {
        var url = Settings.wsUrl + "/" + type + "?crop=true&useranking=" + (Settings.useRanking ? "true" : "false") + "&filter=" + query + "&top=" + Settings.itemsPerPage;
        if (Settings.fixedFilter) url += "&" + Settings.fixedFilter;
        if (results && results.rows.length > 0) {
            url += "&skip=" + results.rows.length;
        }
        if (selectedFacets && selectedFacets.length > 0) {
            selectedFacets.forEach(function (facet) {
                url += "&" + facet
            });
        }

        for (const key in Settings.fixedQueryFilters) {
            if (Settings.fixedQueryFilters.hasOwnProperty(key) && Settings.fixedQueryFilters[key] && Settings.fixedQueryFilters[key].length > 0) {
                Settings.fixedQueryFilters[key].map(v => {
                    url += `&${key}=${encodeURIComponent(v)}`;
                });
            };
        }

        return url;
    },
    constructNewQueryUrl(type, query, selectedFacets) {
        var url = Settings.wsUrl + "/" + type + "?crop=true&useranking=" + (Settings.useRanking ? "true" : "false") + "&filter=" + query + "&top=" + Settings.itemsPerPage;
        if (Settings.fixedFilter) url += "&" + Settings.fixedFilter;
        if (selectedFacets && selectedFacets.length > 0) {
            selectedFacets.forEach(function (facet) {
                url += "&" + facet
            });
        }
        //these are fixed filters passed through the query string
        for (const key in Settings.fixedQueryFilters) {
            if (Settings.fixedQueryFilters.hasOwnProperty(key) && Settings.fixedQueryFilters[key] && Settings.fixedQueryFilters[key].length > 0) {
                Settings.fixedQueryFilters[key].map(v => {
                    url += `&${key}=${encodeURIComponent(v)}`;
                });
            };
        }

        return url;
    },
    constructNewSDSQueryUrl(query) {
        var url = Settings.sdsWsUrl + "/product/" + encodeURIComponent(this.makeSafe(query));
        return url;
    },

    constructPromotedResultUrl(query) {
        var url = Settings.wsUrl + "/promoted?filter=" + query;
        if (Settings.fixedFilter) url += "&" + Settings.fixedFilter;
        return url;
    },
    applyVisualUpdates(selector) {
        if (selector) {
            setTimeout(function () {
                jQuery(cla).triggerHandler('domchanged', selector)
            }
            );
        }
    },
    processFacetChecked(facets, opt) {
        if (!facets || !opt) return;
        if (opt.checked) {
            facets.push(opt.value);
        }
        else {
            var pos = facets.indexOf(opt.value);
            if (pos != -1) facets.splice(pos, 1);
        }
        return facets;
    },
    getCookie(name) {
        /*var regexp = new RegExp("(?:^" + name + "|;\s*"+ name + ")=(.*?)(?:;|$)", "g");
        var result = regexp.exec(document.cookie);
        return (result === null) ? "" : result[1];*/
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        else return "";
    },
    reportResultsToAnalytics(type, query, results) {
        let description = 'Search' + (Settings.appPrefix ? ('_' + Settings.appPrefix) : '');
        this.reportToAnalytics({
            'event': 'claEvent',
            'description': description,
            'type': type,
            'query': query,
            'results': results
        });
    },
    reportToAnalytics(data) {
        if (!data) return;
        //we need to check if the analytics object exists. If not, we cache the events and submit them when the object becomes available
        let target = this.eventQueue;
        if (typeof (dataLayer) !== "undefined") {
            if (data.type) {
                console.log(`Submitting ${data.type} results to analytics`);
            } else {
                console.log(`Submitting data to analytics`);
            }
            target = dataLayer;
        }
        else if (this.timer == null) {
            console.log("Setting up analytics timer.")
            this.timer = setInterval(() => {
                console.log("Checking if analytics object is available.");
                if (typeof (dataLayer) !== "undefined") {
                    console.log("Analytics object found. Submitting data.")
                    clearInterval(this.timer);
                    if (this.eventQueue.length > 0) {
                        dataLayer.splice(dataLayer.length, 0, this.eventQueue);
                        this.eventQueue = [];
                    }
                }
                else {
                    this.retryCount++;
                    if (this.retryCount > 10) {
                        console.log("Giving up on pushing search data to analytics.")
                        clearInterval(this.timer);
                    }
                }
            }, 3000);
        }

        target.push(data);
    },
    getMonthName(index) {
        //we assume it's a 1-based index
        if (typeof (index) !== "number") return "";
        if (index > 0 && index <= 12) {
            if (this.monthNames.length === 0) {
                this.monthNames = Labels.monthNames.split(",");
            }
            return this.monthNames[index - 1];
        } else return "";
    },
    getIsoDate(date) {
        if (!date || typeof (date) !== "object") return "";
        return `${date.getFullYear()}-${(this.twoDigits(date.getMonth() + 1))}-${this.twoDigits(date.getDate())}`
    },
    twoDigits(x) {
        if (x < 10) return `0${x}`;
        else return `${x}`;
    },
    makeSafe(src) {
        //we replace characters not safe for paths with spaces
        if (!src) return "";
        return src.replace(/[^a-z0-9]/gi, ' ').trim();
    },
    shortIdToGuid(input) {
        if (!input || input.length !== 32) return;
        let output = `{${input.substring(0, 8)}-${input.substring(8, 12)}-${input.substring(12, 16)}-${input.substring(16, 20)}-${input.substring(20, 32)}}`;
        return output.toUpperCase();
    },
    offsetToTimezoneId(offset, date) {
        if (!offset || !date) return stdTimezones["Z"];
        let dt = typeof (date) === "object" ? date : new Date(date);
        let stdTimezoneOffset = Math.max(new Date(dt.getFullYear(), 0, 1).getTimezoneOffset(), new Date(dt.getFullYear(), 6, 1).getTimezoneOffset());
        let isDaylight = dt.getTimezoneOffset() < stdTimezoneOffset;
        let table = isDaylight ? dsTimezones : stdTimezones;
        if (table.hasOwnProperty(offset)) return table[offset];
        else return table["Z"];
    },
    showStatusMessage(msg, color, duration) {
        if (!msg) return;
        color = color || "green";
        duration = duration | 5000;
        let messageBox = document.createElement("div");
        messageBox.classList.add("cla-messagebox");
        messageBox.classList.add(color);
        messageBox.innerHTML = msg;
        document.body.appendChild(messageBox);
        setTimeout(() => {
            if (messageBox) {
                messageBox.style.opacity = '0';
                setTimeout(() => {
                    messageBox.remove();
                }, 500);
            }
        }, duration);
    },
}